<template>
  <card-container :title="title" style="max-width: 600px">
    <file-upload no-button @attached="load_image" />

    <div v-if="img_b64 !== ``" class="w-100 py-4 px-2 text-center">
      <img
        :src="img_b64"
        alt="image"
        class="img-fluid"
        style="max-width: 400px; max-height: 400px"
      />
    </div>
    <div v-if="buttons" class="d-flex flex-row mt-3">
      <div class="flex-grow-1 text-left pe-2">
        <button
          v-if="buttons.includes(`save`)"
          :disabled="img_b64.trim() === ``"
          class="btn btn-primary"
          @click="save_image"
        >
          Save
        </button>
      </div>
      <div class="px-2">
        <button v-if="buttons.includes(`clear`)" class="btn btn-danger" @click="clear_image">
          Clear
        </button>
      </div>
      <div class="ps-2">
        <button
          v-if="buttons.includes(`close`)"
          class="btn btn-outline-secondary"
          @click="close_image"
        >
          Close
        </button>
      </div>
    </div>
  </card-container>
</template>

<script>
  export default {
    name: 'ImageUpload',
    components: {},
    props: {
      title: { type: String, default: 'Attach or copy/paste image' },
      buttons: {
        type: Array,
        default: () => {
          return ['save', 'clear', 'close']
        },
      },
      includeFilename: { type: Boolean, default: false }, // emits: {filename: xxx, base64: xxx} instead of `b64`
      uploadOnPaste: { type: Boolean, default: true },
    },
    emits: ['clear', 'close', 'save'],
    data() {
      return { img_b64: '', filename: null }
    },
    mounted() {
      window.addEventListener('paste', this.paste_image)
    },
    beforeUnmount() {
      window.removeEventListener('paste', this.paste_image)
    },
    methods: {
      clear_image() {
        this.$emit('clear', true)
      },
      close_image() {
        this.$emit('close', true)
      },
      save_image() {
        if (this.includeFilename) {
          this.$emit(`save`, { filename: this.filename, base64: this.img_b64 })
        } else {
          this.$emit(`save`, this.img_b64)
        }
      },
      load_image(e) {
        let f = null
        if (e.target.files) {
          f = e.target.files[0]
        } else if (e.dataTransfer) {
          f = e.dataTransfer.files[0]
        } else {
          this.$toast.error('Undefined Error - Could not process file', { duration: 3000 })
          return
        }
        this.filename = f.name
        const reader = new FileReader()
        reader.onload = this.set_image
        reader.readAsDataURL(f)
      },
      set_image(event) {
        this.img_b64 = event.target.result
      },
      set_image_and_save(event) {
        this.img_b64 = event.target.result
        if (this.uploadOnPaste) {
          this.save_image()
        }
      },
      paste_image(e) {
        const items = (e.clipboardData || e.originalEvent.clipboardData).items
        // find pasted image among pasted items
        let blob = null
        for (const item of items) {
          if (item.type.indexOf('image') === 0) {
            this.filename = 'clipboard.png'
            blob = item.getAsFile()
          }
        }

        // load image if there is a pasted image
        if (blob !== null) {
          const reader = new FileReader()
          reader.onload = this.set_image_and_save
          reader.readAsDataURL(blob)
        }
      },
    },
  }
</script>

<style scoped></style>
